import '../css/ConnectionPublicPage.css';
import React, { useState, useEffect } from 'react';

function App() {
  const [serial_number, setSerialNumber] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const serial = params.get('serial_number');
    if (serial) {
      setSerialNumber(serial);
    }
  }, []);

  return (
    <div className="body">
      <div className="main">
        <div className="sections">
          <div className="background"></div>

          <div className="logo">
            <div className="kllogo">
              <a href="https://www.katlai.com/">
                <img src={require('../components/logo/katlai-logo-black.png')} className="KLLOGO" />
              </a>
            </div>
            <div className="kltitle">
              <h1 className="KLTITLE_new">
                AromaPod Pro by KATLAI <br /> 
              </h1>
            </div>
          </div>

          <div className="textBox">
            <div className="caption">
              <p className="text1">Congratulations on your upgrade!</p>
              <p className="text2">Select a channel to connect with us and elevate your wellness journey.</p>
              <p className="text-small mt-4">
                By clicking a button, you agree to<br />our&nbsp;
                <a
                  href="https://www.katlai.com/app-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-1"
                >
                  Privacy Policy
                </a>
                &nbsp;and <a
                  href="https://www.katlai.com/app-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-1"
                >
                  Data Collection Terms
                </a>.
              </p>
            </div>


          </div>

          <div className="socialmedia">
            {/* WhatsApp Button */}
            <div className="StyledContainer_new">
              <a
                href={`https://wa.me/85293789122?text=/start%20qr_code--CI`}
                className="links"
              >
                <img src={require('../components/icon/whatsapp.png')} className="icons" />
                <p className="StyledText">WhatsApp AI Assistant</p>
              </a>
            </div>

            {/* Facebook Button (Disabled with Coming Soon!) */}
            <div className="StyledContainer_new">
              <a
                href={`https://app.usesalesbot.io/p/facebook/vzjubqaifiuo5s9q?ref=-uflow::f132639s1474259::live::49399`}
                className="links disabled-link"
              >
                <img src={require('../components/icon/facebook.png')} className="icons" />
                <p className="StyledText">Facebook AI Assistant</p>
              </a>
            </div>

            {/* Webapp Button */}
            <div className="StyledContainer_new">
              <a
                href={`https://app.usesalesbot.io/p/web/vzjubqaifiuo5s9q?ref=-uflow::f132639s1474259::live::49399`}
                className="links"
              >
                <img src={require('../components/icon/website.png')} className="icons" />
                <p className="StyledText">Webapp AI Assistant</p>
              </a>
            </div>



            {/* Instagram Button (Disabled with Coming Soon!) */}
            {/* <div className="StyledContainer disabled">
              <a href="#" className="links disabled-link">
                <img src={require('./icon/instagram.png')} className="icons" />
                <p className="StyledText">Instagram (Coming Soon!)</p>
              </a>
            </div> */}

            {/* Telegram Button (Disabled with Coming Soon!) */}
            {/* <div className="StyledContainer disabled">
              <a href="#" className="links disabled-link">
                <img src={require('./icon/telegram.png')} className="icons" />
                <p className="StyledText">Telegram (Coming Soon!)</p>
              </a>
            </div> */}

            {/* WeChat Button (Disabled with Coming Soon!) */}
            {/* <div className="StyledContainer disabled">
              <a href="#" className="links disabled-link">
                <img src={require('./icon/wechat.png')} className="icons" />
                <p className="StyledText">WeChat (Coming Soon!)</p>
              </a>
            </div> */}

            {/* Slack Button (Disabled with Coming Soon!) */}
            {/* <div className="StyledContainer disabled">
              <a href="#" className="links disabled-link">
                <img src={require('./icon/slack.png')} className="icons" />
                <p className="StyledText">Slack (Coming Soon!)</p>
              </a>
            </div> */}

            {/* Line Button (Disabled with Coming Soon!) */}
            {/* <div className="StyledContainer disabled">
              <a href="#" className="links disabled-link">
                <img src={require('./icon/line.png')} className="icons" />
                <p className="StyledText">Line (Coming Soon!)</p>
              </a>
            </div> */}

            {/* Viber Button (Disabled with Coming Soon!) */}
            {/* <div className="StyledContainer disabled">
              <a href="#" className="links disabled-link">
                <img src={require('./icon/viber.png')} className="icons" />
                <p className="StyledText">Viber (Coming Soon!)</p>
              </a>
            </div> */}


          </div>
        </div>
      </div>
    </div>
  );
}

export default App;